import { apiClient, API_CONFIG } from '../../core';
import type { ApiResponse } from '../../shared';
import type { LC_GetServerTimeOut } from './serverTime.types';


export class ServerTimeService {
  async get(): Promise<ApiResponse<LC_GetServerTimeOut>> {
    return apiClient.get<LC_GetServerTimeOut>(API_CONFIG.ENDPOINTS.SERVER_TIME.GET);
  }
}

export const serverTimeService = new ServerTimeService();
